type MeLike = { can_manage_agents?: boolean } | null;

/** Shown wherever an agent control is disabled for lack of the permission. */
export const MANAGE_AGENTS_HINT = 'Only the owner can manage agents.';

/**
 * Whether the current member may create, edit, delete or switch agents. The
 * server-derived `can_manage_agents` on `members/me/`, mirroring
 * `can_manage_knowledge`; the backend enforces the same rule on every agent
 * write (403 otherwise). A server that predates the flag sends no field: that
 * reads as allowed, so an older backend never locks the owner out of the UI --
 * the server still refuses anyone it should.
 */
export function canManageAgents(me: MeLike | undefined): boolean {
  return me?.can_manage_agents !== false;
}
